import {AlertIcon} from '@primer/octicons-react'
import styles from './CondensedMergeStatus.module.css'

export function CondensedMergeStatusErrorFallback() {
  return (
    <ul className={styles.statusList}>
      <li className={styles.statusRow}>
        <span style={{color: 'var(--fgColor-attention)', display: 'flex'}}>
          <AlertIcon size={16} />
        </span>
        <span className={styles.statusText}>Unable to load merge status</span>
      </li>
    </ul>
  )
}
